// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_eW","advertDetailHeaderLocation__value":"c-m_eX"};